var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62087 6.50943L1.24229 1.16406C1.18973 1.11217 1.14813 1.05025 1.11993 0.981991C1.09173 0.913727 1.07752 0.840499 1.07814 0.766644C1.07876 0.692788 1.09419 0.619808 1.12352 0.552024C1.15285 0.484241 1.19549 0.423035 1.24891 0.372028C1.35817 0.267528 1.50387 0.209749 1.65505 0.210972C1.80624 0.212195 1.95098 0.272323 2.05854 0.378578L7.8346 6.11926C7.88686 6.17077 7.92831 6.23218 7.95656 6.29989C7.9848 6.36761 7.99926 6.44028 7.99909 6.51365C7.99891 6.58702 7.98412 6.65962 7.95556 6.72721C7.92701 6.79479 7.88526 6.85601 7.83277 6.90727L1.7983 12.846C1.69027 12.9512 1.54565 13.0102 1.39492 13.0108C1.24419 13.0114 1.09913 12.9534 0.990308 12.8491C0.937135 12.7978 0.894786 12.7364 0.865769 12.6685C0.836752 12.6006 0.821658 12.5276 0.82138 12.4537C0.821102 12.3799 0.835645 12.3067 0.864149 12.2386C0.892654 12.1705 0.934539 12.1087 0.987325 12.0571L6.62087 6.50943Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.4f9c78ba8c044636788b40886b9c25f3.svg";
export { ForwardRef as ReactComponent };